// features/ui/uiSlice.js
import { createSlice } from "@reduxjs/toolkit";

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    loadingCount: 0,
    loading: false,
    scale: 1,
    mode: "pc",
  },
  reducers: {
    startLoading(state) {
      state.loadingCount += 1;
      state.loading = true;
    },
    stopLoading(state) {
      if (state.loadingCount > 0) {
        state.loadingCount -= 1;
      }
      if (state.loadingCount === 0) {
        state.loading = false;
      }
    },
    setScale(state, action) {
      state.scale = action.payload;
      // BASE_WIDTH(1920) 기준 0.4 = 폭 768px 미만이면 모바일
      if (action.payload < 0.4) {
        state.mode = "mobile";
      } else {
        state.mode = "pc";
      }
    },
  },
});

export const { startLoading, stopLoading, setScale } = uiSlice.actions;
export default uiSlice.reducer;
